import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {FaIconComponent} from '@fortawesome/angular-fontawesome';
import {faCheck, faXmark} from '@fortawesome/pro-solid-svg-icons';
import {BicButtonComponent, TooltipDirective} from '@buildinginformationcloud/bic-ui-components';

/**
 * Das ✓/✗-Paar, mit dem der Nutzer über eine einzelne Änderung eines chatBIC-Vorschlags entscheidet
 * (Feld, Prompt, Listenabschnitt, Parameterzeile, entfernter Eintrag). Zwei `bic-button` im Modus
 * `iconOnly` (je 38×38 px, weiß, Haken grün, X rot) – das Paar ist samt `gap-1` also genau 80 px breit;
 * darauf bauen `ProposalRowComponent.GUTTER_PX` und das rechte Padding des Block-Rahmens in
 * `app-change-marker` auf.
 *
 * Die Labels dienen zugleich als Tooltip (`tooltip`-Direktive am Wrapper, da `bic-button` sein `title`
 * nicht rendert) und als `aria-label` der Buttons; für entfernte
 * Einträge übergibt der Aufrufer „Löschen übernehmen“ / „Behalten“.
 *
 * Kein `stopPropagation`: Reagiert ein Elternelement selbst auf Klicks (z. B. der aufklappbare
 * IDS-Facettenkopf), umschließt der Aufrufer das Paar mit `<div (click)="$event.stopPropagation()">`.
 */
@Component({
  selector: 'app-proposal-actions',
  standalone: true,
  imports: [BicButtonComponent, FaIconComponent, TooltipDirective],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './proposal-actions.component.html',
})
export class ProposalActionsComponent {
  @Input() acceptLabel = 'Änderung übernehmen';
  @Input() rejectLabel = 'Änderung verwerfen';
  @Output() acceptClicked = new EventEmitter<void>();
  @Output() rejectClicked = new EventEmitter<void>();

  protected readonly faCheck = faCheck;
  protected readonly faXmark = faXmark;
}
